import React, { useState } from "react";
import NumberFormat from 'react-number-format';

const Input = (props: any) => {
  const [hasValue, setHasField] = useState("");

  function handleBlur(e: any) {
    if (e.target.value !== "") setHasField("form__input--hasValue");
    else setHasField("");
    /*e.target.setCustomValidity("");
    if (!e.target.validity.valid) {
      e.target.setCustomValidity(props.errorMsg);
    }*/
  }

  return (
    <div className="form-group">
        <label htmlFor={props.name} className="form-label form__label">{props.title} </label>
        { props.masked !== undefined ? (
          <NumberFormat //{...props} 
            className={`form-input form__input ${hasValue}  ${props.title.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/gi, "").replace(/\W+/gi, '')}`}
            id={props.id || props.name}
            name={props.name}
            //value={props.value}
            defaultValue={props.value}
            onChange={props.handleChange}
            placeholder={props.placeholder}
            defaultChecked={props.checked}
            readOnly={props.readOnly}
            disabled={props.disabled}
            step={props.step}
            pattern={props.pattern}
            required={props.required}
            maxLength={props.maxLength}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={0}
            isNumericString={true}
            allowLeadingZeros={false}
            onBlur={(e: any) => {
              handleBlur(e);
            }}
          />) :
          (<input
              className={`form-input form__input ${hasValue}`}
              id={props.id || props.name}
              name={props.name}
              type={props.type}
              defaultValue={props.value}
              onChange={props.handleChange}
              placeholder={props.placeholder}
              defaultChecked={props.checked}
              readOnly={props.readOnly}
              disabled={props.disabled}
              step={props.step}
              pattern={props.pattern}
              required={props.required}
              maxLength={props.maxLength}
              onBlur={(e) => {
                  handleBlur(e);
              }}
          />)
          }
    </div>
  );
};
export default Input;
